import { render, staticRenderFns } from "./TurnoversAndReports.vue?vue&type=template&id=25cf38b6&"
import script from "./TurnoversAndReports.vue?vue&type=script&lang=ts&"
export * from "./TurnoversAndReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports